/* FURVIBE — one-tap "complete the set" adds. Dispatches Shopify's standard cart event so
   Horizon's cart drawer refreshes (Section Rendering) and auto-opens like a normal add. */
import { CartLinesUpdateEvent } from '@shopify/events';

if (!window.__fvPairs) {
  window.__fvPairs = true;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  document.addEventListener('change', (e) => {
    const sel = e.target.closest && e.target.closest('[data-fv-pair-select]');
    if (!sel) return;
    const row = sel.closest('.fv-pair');
    const opt = sel.selectedOptions[0];
    const btn = row && row.querySelector('[data-fv-pair-add]');
    if (btn && opt) btn.setAttribute('data-fv-pair-add', opt.value);
    const price = row && row.querySelector('[data-fv-pair-price]');
    if (price && opt && opt.dataset.price) price.textContent = opt.dataset.price;
  });

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest && e.target.closest('[data-fv-pair-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    const variantId = btn.getAttribute('data-fv-pair-add');
    btn.disabled = true;
    btn.classList.add('is-busy');
    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((el) => el.dataset.sectionId).filter(Boolean);
    const done = () => { btn.classList.remove('is-busy'); btn.disabled = false; };
    let res;
    try {
      res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: sectionIds.join(',') }),
      }).then((r) => r.json());
    } catch (err) {
      done();
      return;
    }
    if (res.status) {
      // Sold out / limit reached: say so on the button instead of failing silently.
      const label = btn.querySelector('.fv-pair__add-label');
      if (label) {
        const prev = label.textContent;
        label.textContent = 'Sold out';
        setTimeout(() => { label.textContent = prev; }, 2200);
      }
      done();
      return;
    }
    // Dispatch only after a successful add, so the drawer never opens over an error.
    const deferred = CartLinesUpdateEvent.createPromise();
    btn.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add', context: 'product',
      lines: [{ merchandiseId: String(variantId), quantity: 1 }],
      promise: deferred.promise,
    }));
    try {
      const cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { items: cart.items, source: 'fv-pairs', itemCount: 1, sections: res.sections, didError: false },
      });
    } catch (err) {
      deferred.resolve({ cart: null, detail: { sections: res.sections, source: 'fv-pairs', didError: false } });
    }
    btn.classList.remove('is-busy');
    btn.classList.add('is-done');
    setTimeout(() => { btn.classList.remove('is-done'); btn.disabled = false; }, 1800);
  });
}
